import { inject, Injectable } from '@angular/core';

import { SnCurrentOrganization } from '@lib/auth';

import { ViLPRProvider } from '../../models';

/** Checks which LPR integrations are enabled for the current organization */
@Injectable({ providedIn: 'root' })
export class ViLPRProviderIntegrationService {
  private readonly currentOrganizationService = inject(SnCurrentOrganization);

  get isVehicleIntelligenceEnabled(): boolean {
    return this.isIntegrationEnabled(ViLPRProvider.AXON_VI);
  }

  get isVigilantEnabled(): boolean {
    return this.isIntegrationEnabled(ViLPRProvider.VIGILANT);
  }

  get isFlockEnabled(): boolean {
    return this.isIntegrationEnabled(ViLPRProvider.FLOCK);
  }

  get isFlockV3Enabled(): boolean {
    return this.isIntegrationEnabled(ViLPRProvider.FLOCK_V3);
  }

  get isFususEnabled(): boolean {
    return true;
  }

  private isIntegrationEnabled(name: string): boolean {
    return this.currentOrganizationService.enabledIntegrations.includes(name);
  }
}
